<template>
    <div class="vx-row">
        <!-- COL 1 -->
        <div class="vx-col w-full lg:w-3/3">
            <vs-card style="height:200px; overflow-y: scroll">
                <div slot="header">
                    <h5>Importer le fichier</h5>
                </div>
                <div>
                    <vs-col class="kijinput" vs-type="flex" vs-justify="left" vs-align="left" vs-w="12">

                        <input
                                width="500px"
                                type="file"
                                label="Importer un fichier d'utilisateurs"
                                ref="updateImgInput"
                                id="updateImgInput"
                                @change="updateCurrImg"
                                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                v-on:change="handleFileUpload()"
                                :danger="formErrors"
                                :danger-text="'Le fichier contient des erreurs'"
                        />
                    </vs-col>
                    <small v-if="!formErrors && import_message" style="padding-left: 10px; color: indianred">{{import_message}}</small>
                    <br>
                    <vs-col class="kijinput" vs-type="flex" vs-justify="left" vs-align="left" vs-w="12">
                        <vs-button color="primary" type="filled" @click="importBashFile()">Enregistrer</vs-button>
                    </vs-col>
                    <br>
                    <vs-row v-if="formErrors">
                        <ul>
                            <li v-for="(item, index) in formErrors" :key="index">
                                <small style="color: red">{{formErrors[index][0]}}</small>
                            </li>
                        </ul>
                    </vs-row>
                </div>
            </vs-card>
        </div>

        <div class="vx-col w-full lg:w-1/2">
            <vs-card>
                <div slot="header">
                    <h5>Références des équipes</h5>
                </div>
                <div>
                    <vs-table :data="teams" max-items="5" search pagination>

                        <template slot="thead">
                            <vs-th>Référence</vs-th>
                            <vs-th>Nom</vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                <vs-td :data="data[indextr].slug">
                                    {{ data[indextr].slug }}
                                </vs-td>

                                <vs-td :data="data[indextr].name">
                                    {{ data[indextr].name }}
                                </vs-td>
                            </vs-tr>
                        </template>

                    </vs-table>
                </div>
            </vs-card>
        </div>
        <div class="vx-col w-full lg:w-1/2">
            <vs-card>
                <div slot="header">
                    <h5>Références des régions</h5>
                </div>
                <div>
                    <vs-table :data="regions" max-items="5" search pagination>

                        <template slot="thead">
                            <vs-th>Référence</vs-th>
                            <vs-th>Nom</vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                <vs-td :data="data[indextr].slug">
                                    {{ data[indextr].slug }}
                                </vs-td>

                                <vs-td :data="data[indextr].name">
                                    {{ data[indextr].name }}
                                </vs-td>
                            </vs-tr>
                        </template>

                    </vs-table>
                </div>
            </vs-card>
        </div>

        <div class="vx-col w-full lg:w-1/2">
            <vs-card>
                <div slot="header">
                    <h5>Références des fonctions</h5>
                </div>
                <div>
                    <vs-table :data="fonctions" max-items="5" search pagination>

                        <template slot="thead">
                            <vs-th>Référence</vs-th>
                            <vs-th>Nom</vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                <vs-td :data="data[indextr].slug">
                                    {{ data[indextr].slug }}
                                </vs-td>

                                <vs-td :data="data[indextr].name">
                                    {{ data[indextr].name }}
                                </vs-td>
                            </vs-tr>
                        </template>

                    </vs-table>
                </div>
            </vs-card>
        </div>

        <div class="vx-col w-full lg:w-1/2">
            <vs-card>
                <div slot="header">
                    <h5>Références des rôles</h5>
                </div>
                <div>
                    <vs-table :data="roles" max-items="5" search pagination>

                        <template slot="thead">
                            <vs-th>Référence</vs-th>
                            <vs-th>Nom</vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                <vs-td :data="data[indextr].slug">
                                    {{ data[indextr].slug }}
                                </vs-td>

                                <vs-td :data="data[indextr].name">
                                    {{ data[indextr].name }}
                                </vs-td>
                            </vs-tr>
                        </template>

                    </vs-table>
                </div>
            </vs-card>
        </div>


    </div>
</template>

<script>
    export default {
        name: 'createByBashFile',
        data: () => ({
            selected: [],
            lines: [],

            deletePopupItem: false,
            showBashFileImportStoreItem: false,
            param: new FormData(),

            loading: false,
            itemsPerPage: 4,
            isMounted: false,
            users: [],
            highlightedFn: {
                customPredictor(date) {
                    if (date.getDate() === new Date().getDate()) {
                        return true;
                    }
                }
            },
            params: {
                page: 1,
                type: "",
                limit: 6
            },
            settings: {
                maxScrollbarLength: 600,
                wheelSpeed: 0.6
            },
            url: "/users",
            file: "",
            formErrors: {},
            itemToDelete: "",
            import_message: "",
            teams: [],
            regions: [],
            fonctions: [],
            roles: [],
        }),
        methods: {
            handleFileUpload() {
                this.file = this.$refs.updateImgInput.files[0];

                this.formErrors = {};
            },
            updateCurrImg() {
            },
            resetErrors(field) {
                this.import_message = ""
                if (field) {
                    this.formErrors[field] = null;
                } else {
                    this.formErrors = [];
                    Object.keys(this.input).forEach(index => (this.input[index] = null));
                }
            },
            async importBashFile() {
                this.$vs.loading();
                let formData = new FormData();
                formData.append("file", this.file);

                this.$http
                    .post(this.url + "/bash/file/store", formData)
                    .then(response => {
                        window.getApp.success(
                            "Voici l'historique de votre importation.",
                            {}
                        );
                        this.showBashFileImportStoreItem = false;

                        this.$router.push({path: '/users/add-import-history/' + response.data.history })
                    })
                    .catch(error => {
                        this.$vs.loading.close();
                        this.$vs.notify({
                            title: "Erreur",
                            text: error.response.data.message,
                            color: "danger",
                            position: "top-right",
                            iconPack: "feather",
                            icon: "icon-alert-circle"
                        });
                        if (error.response.data.status_code === 422) {
                            this.formErrors = error.response.data.errors;
                            this.import_message = error.response.data.message
                        }
                    });
            },
            getTeams() {
                this.$http.get("/teams").then(response => {
                    this.teams = response.data;
                });
            },
            getRegions() {
                this.$http.get("/regions").then(response => {
                    this.regions = response.data.data;
                });
            },
            getFonctions() {
                this.$http.get("/functions").then(response => {
                    this.fonctions = response.data.data;
                });
            },
            getRoles() {
                this.$http.get("/roles").then(response => {
                    this.roles = response.data.data;
                });
            },
        },
        created() {
            this.getTeams();
            this.getRegions();
            this.getFonctions();
            this.getRoles();
        },
    }
</script>

<style>
    .kijinput {
        padding: 5px;
        /* padding-left: 15px; */
    }

    #updateImgInput {
        border: 1px solid rgba(0, 0, 0, 0.2);
        padding: 0.7rem;
        font-size: 1rem;
        width: 500px;
        color: inherit;
        position: relative;
        border-radius: 11px;
        height: fit-content;
    }

    .vs-input--input {
        width: 500px;
    }

    .vs-input--label {
        padding-left: 1px !important;
    }

    .kijinput {
        padding: 5px;
        /* padding-right: 15px; */
    }

    .otdclas {
        height: 300px;
        /* width: 300px; */
    }
</style>